import NavbarComponent from "./NavbarComponent";
import Footer from "./Footer";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const Layout = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <NavbarComponent />
      <main className="flex-1 pt-16 md:pt-20">{children}</main>
      <Footer />
    </div>
  );
};